import React from "react";
import { makeStyles, Collapse } from "@material-ui/core";
import clsx from "clsx";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import PlannerSection from "../PlannerSection";

const ScheduledForTransport = ({
  transfersLength,
  rolesAndFeatures,
  transferMode,
  setTransferMode,
  updatedTransfers,
  checks,
  updateChecks,
  setCurrentTransferId,
  setCurrentBookingId,
  setShowVehicleModal,
  assignToMeClick,
  selectedLocationId,
  selectedDay,
  plannerStore,
  setErrorMessage,
  showAdHocRequestModal,
  setCurrentTripPlannerId,
}: any) => {
  const classes = useStyles();
  const [isCollapsed, setIsCollapsed] = React.useState(false);

  const headerSubTitle = `${transfersLength} Transfer${transfersLength > 1 ? "s" : ""}`;

  return (
    <div className={classes.root}>
      <div className={classes.heading}>
        <div
          className={classes.headWrapping}
          onClick={() => {
            setIsCollapsed(!isCollapsed);
          }}
        >
          {!isCollapsed ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
          <span className={classes.headerTitle}>Scheduled For Transport</span>
          {isCollapsed && <span className={classes.headerSubTitle}>{headerSubTitle}</span>}
        </div>

        {rolesAndFeatures.transerSwitch && !isCollapsed && (
          <div className={classes.transferSwitchContainer}>
            <span
              onClick={() => {
                setTransferMode(0);
              }}
              className={clsx(classes.transerSwitch, {
                [classes.transerSwitchActive]: transferMode === 0,
              })}
            >
              All Transfers
            </span>
            <span
              onClick={() => {
                setTransferMode(1);
              }}
              className={clsx(classes.transerSwitch, {
                [classes.transerSwitchActive]: transferMode === 1,
              })}
            >
              {rolesAndFeatures.transerSwitchRightText}
            </span>
          </div>
        )}
      </div>
      <Collapse in={!isCollapsed} timeout="auto" unmountOnExit>
        <PlannerSection
          selectedLocationId={selectedLocationId}
          selectedDay={selectedDay}
          roles={rolesAndFeatures}
          transferMode={transferMode}
          updatedTransfers={updatedTransfers}
          checks={checks}
          updateChecks={updateChecks}
          setCurrentTransferId={setCurrentTransferId}
          setCurrentBookingId={setCurrentBookingId}
          setShowVehicleModal={setShowVehicleModal}
          assignToMeClick={assignToMeClick}
          plannerStore={plannerStore}
          setErrorMessage={setErrorMessage}
          showAdHocRequestModal={showAdHocRequestModal}
          setCurrentTripPlannerId={setCurrentTripPlannerId}
        />
      </Collapse>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#00152E",
    marginTop: 15,
  },
  heading: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 28,
  },
  headWrapping: {
    cursor: "pointer",
    paddingLeft: 14,
    display: "flex",
    alignItems: "center",
  },
  headerTitle: {
    fontSize: 21,
    fontWeight: 400,
    marginLeft: 15,
  },
  headerSubTitle: {
    fontSize: 21,
    fontWeight: 500,
    opacity: 0.36,
    marginLeft: 15,
  },
  transferSwitchContainer: {
    display: "inline-flex",
    float: "right",
    marginRight: 25,
    border: "1px solid #02489D",
    borderRadius: 20,
    overflow: "hidden",
  },
  transerSwitch: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 150,
    height: 32,
    fontSize: 14,
    fontWeight: 500,
    cursor: "pointer",
  },
  transerSwitchActive: {
    backgroundColor: "#02489D",
  },
}));

export default ScheduledForTransport;
